import { render, staticRenderFns } from "./router.vue?vue&type=template&id=9f76a7f6&"
import script from "./router.vue?vue&type=script&lang=ts&"
export * from "./router.vue?vue&type=script&lang=ts&"
import style0 from "./router.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports